type Props = {
    width?:number;
    height?:number;
    fill?:string;
}

const EditIcon = ({
    width =20,
    height=20,
    fill="none"
}: Props) =>{
    return (
      <svg width={width} height={height} viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M16.1423 5.18198L14.5682 3.62758L7.62137 10.4903V12.0447H9.19494L16.1423 5.18198ZM17.897 6.42499L10.0177 14.2083H5.6369V9.88084L13.5162 2.09757C14.0978 1.52306 15.0401 1.52306 15.6217 2.09757L17.897 4.3451C18.4786 4.9196 18.4786 5.85048 17.897 6.42499ZM17.0494 11.4707H17.5456V16.8628C17.5456 17.675 16.8792 18.3334 16.0569 18.3334H3.15522C2.33295 18.3334 1.6665 17.675 1.6665 16.8628V4.11777C1.6665 3.30552 2.33295 2.64719 3.15522 2.64719H8.61434V3.13738C8.61434 3.94963 7.9474 4.60796 7.12563 4.60796H3.65146V16.3726H15.5607V12.9412C15.5607 12.129 16.2276 11.4707 17.0494 11.4707Z" fill="#E87722"/>
</svg>

    )
}

export default EditIcon;